import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'

interface IButtonProps {
  isActive?: boolean
}

export const Button = styled('div')<IButtonProps>`
  border-radius: 4px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  padding: 6px 4px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${colors.gray220};
  }

  ${({ isActive }) => isActive && `background: ${colors.gray220};`}
`

export const ButtonWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ isActive }) =>
    isActive &&
    css`
      border-left: 1px solid gray;
      padding-left: 4px;
    `}
`

export const SaveButton = styled('div')`
  border-radius: 4px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  padding: 6px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;

  &:hover {
    background: ${colors.gray220};
  }
`
